import { TimerSandIcon } from './TimerSandIcon';

/**
 * author: Austin Andrews
 * id 64EFBA89-F8CB-4193-8656-A83CCBC66A76
 * name timer-sand
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand.svg
 * tags
 * - Date / Time 
 */
export const HourglassIcon = TimerSandIcon;
export default HourglassIcon